import axios from "axios"
import type { CognitoClientOptions } from "./CognitoClientOptions"
import type { TokenResponse } from "./TokenResponse"

export const fetchTokenWithCode = ({ clientId, host, redirectUri }: CognitoClientOptions, code: string) =>
	axios.post<TokenResponse>(
		`https://${host}/oauth2/token?grant_type=authorization_code&client_id=${clientId}&redirect_uri=${redirectUri}&code=${code}`,
		{},
		{
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
		},
	)
